export const PATIENT_GET_PROFILE = '/company/patients/:patientUuid'
export const PATIENT_GET_ACTIVE_PROGRAM =
  '/company/patients/:patientUuid/enrolled-programs/active'
export const PATIENT_GET_ALL_PROGRAMS =
  '/company/patients/:patientUuid/enrolled-programs'

export const PATIENT_GET_ASSIGNED_MEASUREMENT =
  '/workflow/patient/:patientUuid/measurement/assigned'
export const PATIENT_GET_VITAL_GRAPH =
  '/workflow/measurement/:patientUuid/vital-graph'
export const PATIENT_GET_ACTIVITY_LOG =
  '/workflow/patient/:patientUuid/activityLog'

export const PATIENT_GET_ACTIVITY_LOG_EXPORT =
  '/workflow/patient/:patientUuid/activityLog/export'
export const PATIENT_GET_ACTIVITY_LOG_EXPORT_PDF =
  '/workflow/patient/:patientUuid/activityLog/export-pdf'

export const PATIENT_GET_GOALS = '/workflow/patient/:patientUuid/patient-goal'
export const PATIENT_GET_GOAL_INTERVENTIONS =
  '/workflow/patient-goal/:patientGoalUuid/patient-intervention'
export const PATIENT_GET_CARE_PLAN_REPORT = '/workflow/carePlan/export/pdf'

export const PATIENT_EXTERNAL_DOCUMENT_GET_PATCH_DELETE =
  '/company/patient/document/:attachmentUuid'

export const PATIENT_MEASUREMET_DEFAULT_SORT = {
  sortedColumn: 'startTime',
  sortedColumnOrder: 'descend'
}

export const PATIENT_MEASUREMET_PERIOD: any[] = [
  {
    key: 'period_0',
    value: '',
    title: 'Custom'
  },
  {
    key: 'period_1',
    value: 7,
    title: '7 days'
  },
  {
    key: 'period_2',
    value: 30,
    title: '30 days'
  },
  {
    key: 'period_3',
    value: 90,
    title: '90 days'
  }
]

export const MEASUREMET_TYPES_BY_NUMBERS: Map<number, any> = new Map([
  [
    1,
    {
      value: 1,
      title: 'Weight'
    }
  ],
  [
    2,
    {
      value: 2,
      title: 'Glucose Level'
    }
  ],
  [
    3,
    {
      value: 3,
      title: 'Blood Pressure'
    }
  ],
  [
    4,
    {
      value: 4,
      title: 'Mood'
    }
  ],
  [
    5,
    {
      value: 5,
      title: 'Pain'
    }
  ],
  [
    6,
    {
      value: 6,
      title: 'Temperature'
    }
  ],
  [
    7,
    {
      value: 7,
      title: 'SpO2'
    }
  ],
  [
    8,
    {
      value: 8,
      title: 'Pulse Rate'
    }
  ],
  [
    9,
    {
      value: 9,
      title: 'Respiratory Rate'
    }
  ]
])

export const MEASUREMET_TYPE_LIST = new Map([
  [
    1,
    {
      type: 1,
      title: 'Weight',
      field: 'Weight'
    }
  ],
  [
    2,
    {
      type: 2,
      title: 'Glucose Level',
      field: 'Glucose Level'
    }
  ],
  [
    3,
    {
      type: 3,
      title: 'Blood Pressure',
      field: 'Dia'
    }
  ],
  [
    4,
    {
      type: 4,
      title: 'Mood',
      field: 'Mood'
    }
  ],
  [
    5,
    {
      type: 5,
      title: 'Pain',
      field: 'Pain'
    }
  ],
  [
    6,
    {
      type: 6,
      title: 'Temperature',
      field: 'Temperature'
    }
  ],
  [
    7,
    {
      type: 7,
      title: 'SpO2',
      field: 'SpO2'
    }
  ],
  [
    8,
    {
      type: 8,
      title: 'Pulse Rate',
      field: 'Pulse Rate'
    }
  ],
  [
    9,
    {
      type: 9,
      title: 'Respiratory Rate',
      field: 'Respiratory Rate'
    }
  ]
])

export const MEASUREMENT_GRAPH_GROUP_TYPE: any[] = [
  {
    key: 0,
    value: 0,
    title: 'By Days'
  },
  {
    key: 1,
    value: 1,
    title: 'By Hours'
  }
]

export const MEASUREMET_TYPE_DEFAULT_RANGE = new Map([
  [1, [150, 250]],
  [2, [40, 600]],
  [
    3,
    [
      [50, 275],
      [50, 275]
    ]
  ],
  [4, [1, 10]],
  [5, [1, 10]],
  [6, [90, 108]],
  [7, [50, 100]],
  [8, [40, 180]],
  [9, [5, 40]]
])

export const MEASUREMENT_COMPARE_TYPE_LIST = new Map([
  [
    0,
    {
      value: 1,
      title: 'Less than'
    }
  ],
  [
    1,
    {
      value: 3,
      title: 'Greater than'
    }
  ],
  [
    2,
    {
      value: 2,
      title: 'Between'
    }
  ]
])

export const MOOD_VALUES = new Map([
  [
    1,
    {
      value: 1,
      title: 'Happines (1)'
    }
  ],
  [
    2,
    {
      value: 2,
      title: 'Joy (2)'
    }
  ],
  [
    3,
    {
      value: 3,
      title: 'Proud (3)'
    }
  ],
  [
    4,
    {
      value: 4,
      title: 'Sadness (4)'
    }
  ],
  [
    5,
    {
      value: 5,
      title: 'Fear (5)'
    }
  ],
  [
    6,
    {
      value: 6,
      title: 'Confused (6)'
    }
  ],
  [
    7,
    {
      value: 7,
      title: 'Worry (7)'
    }
  ],
  [
    8,
    {
      value: 8,
      title: 'Anger (8)'
    }
  ],
  [
    9,
    {
      value: 9,
      title: 'Upset (9)'
    }
  ]
])

export const PAIN_VALUES = new Map([
  [
    1,
    {
      value: 1,
      title: 'No pain (1)'
    }
  ],
  [
    2,
    {
      value: 2,
      title: 'Minimal (2)'
    }
  ],
  [
    3,
    {
      value: 3,
      title: 'Mild (3)'
    }
  ],
  [
    4,
    {
      value: 4,
      title: 'Moderate (4)'
    }
  ],
  [
    5,
    {
      value: 5,
      title: 'Distracting (5)'
    }
  ],
  [
    6,
    {
      value: 6,
      title: 'Distressing (6)'
    }
  ],
  [
    7,
    {
      value: 7,
      title: 'Intense (7)'
    }
  ],
  [
    8,
    {
      value: 8,
      title: 'Severe (8)'
    }
  ],
  [
    9,
    {
      value: 9,
      title: 'Unable to move (9)'
    }
  ]
])

export const REPORT_CARE_PLAN_MAX_WORD_LENGTH = 25

export const REPORT_LOGO =
  'data:image/png;base64,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'
